import React, { useCallback, useEffect, useRef, useState } from "react";
import axios, { AxiosResponse } from "axios";
import { DataTableWithoutButtons } from "components/DataTable/DataTableWithoutButtons";
import { AfDataType } from "utils/TableColumnData";
import handleWheel from "utils/handleOnWheel";
import { ListCommanWay, UpdateCommanWay } from "API/commonApi";
import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { Img } from "components";
import moment from "moment";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import Select from "react-select";
import { object } from "yup";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import { utils, write, writeFile } from "xlsx";
import { saveAs } from "file-saver";
import { roles } from "utils/constant";
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";
import Spinner from "utils/Spinner";
import { Table, TableHeader, TableBody, TableColumn, TableRow, TableCell } from "@heroui/table";
import { Chip } from "@nextui-org/react";

const UserSecurity: React.FC<any> = (props) => {
  const ADT = AfDataType;
  const navigator = useNavigate();
  const [tableData, setTableData] = useState<any>([]);
  const [customerList, setcustomerList] = useState<any>([{ value: 0, label: "Loading..." }]);

  const [isFirstLoad, setIsFirstLoad] = useState<any>(true);

  const [currentPage, serCurrentPage] = useState<number>(1);
  const [perPage, setPerPageCount] = useState<number>(25);
  const [pageCount, setPageCount] = useState<number>(1);
  const [itemCount, setItemCount] = useState<number>(1);

  const [filters, setFilters] = useState<any>({});
  const [isFilterChange, setIsFilterChange] = useState(false);

  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const userD = localStorage.getItem("auth") ? JSON.parse(localStorage.getItem("auth")) : {};
  const [userDetails, setUserDetails] = useState<any>(userD?.state?.user || {});
  const tableRef = useRef(null);

  const {
    error: branchError,
    isFetching: branchIsFetching,
    isError: branchIsError,
    isFetched: branchIsFetched,
    isLoading: branchIsLoading,
    refetch: branchRefetch,
  } = useQuery(["CustomersListApi"], () => ListCommanWay("/admin/customer/list", {}, { paginate: 1000 }), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        let opt = [];
        data.data.data.forEach((p) => {
          opt.push({
            value: p.code,
            label: p.code + " - " + p.sh,
          });
        });
        setcustomerList(opt);
      }
    },
  });

  const {
    mutate: updateBookingMutate,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((data) => UpdateCommanWay(data), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        UseToast("Data Updated Successfully", "success");
        performRefetch();
        //navigate("/report/booking");
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const { error, isFetching, isError, isFetched, isLoading, refetch } = useQuery(
    ["_security_user_list".replaceAll("/", "_")],
    () =>
      ListCommanWay("/admin/user/list", filters, {
        include: ["_role_name", "_subbranch"],
        page: currentPage,
        paginate: 100,
      }),
    {
      keepPreviousData: true,
      onSuccess(data) {
        if (data.status == "SUCCESS") {
          setIsFirstLoad(false);
          let tableData = [...(data?.data?.data || [])];
          tableData.forEach((x) => {
            if (!x.extraPerm) {
              x.extraPerm = {};
            } else if (typeof x.extraPerm == "string") {
              x.extraPerm = JSON.parse(x.extraPerm);
            } else {
            }
          });
          setTableData(tableData);
          serCurrentPage(data.data.paginator?.currentPage);
          setPerPageCount(data.data.paginator?.perPage);
          setPageCount(data.data.paginator?.pageCount);
          setItemCount(data.data.paginator?.itemCount);
        }
      },
    }
  );
  const performRefetch = useCallback(() => {
    setTableData([]);
    refetch();
  }, [refetch]);

  useEffect(() => {
    if (isFilterChange) {
      serCurrentPage(1); // Reset page only on filter change
      performRefetch();
      setIsFilterChange(false); // Reset flag after refetch
    } else {
      performRefetch();
    }
  }, [currentPage, isFilterChange, performRefetch]);

  useEffect(() => {
    if (!isFirstLoad) {
      setIsFilterChange(true);
    }
  }, [filters]);

  const { mutate: mutateApproveDeviceId } = useMutation(
    (data) => ListCommanWay("/admin/mac-id/approve", { id: data, apiUrl: "/admin/user/list" }, {}),
    {
      onSuccess: (data: any) => {
        console.log(data, data.status == "SUCCESS");
        if (data.status == "SUCCESS") {
          UseToast("Approval Successfully", "success");
          window.location.reload();
        } else {
          UseToast(data.message, "error");
        }
      },
      onError: (data: any) => {
        typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
      },
    }
  );

  const ExtraPermCell = (key, rd) => (
    <TableCell className="text-center border-x border-gray-300">
      <Chip color={rd.extraPerm?.[key] ? "success" : "danger"} size="sm" variant="solid">
        <span className="font-semibold px-2">{rd.extraPerm?.[key] ? "Yes" : "No"}</span>
      </Chip>
      <br />
      <button
        className="ml-2 text-dark1 font-medium"
        onClick={() => {
          let dataC = { extraPerm: { ...rd.extraPerm, [key]: !rd.extraPerm?.[key] } };
          updateBookingMutate({
            url: "/admin/user/update/" + rd.id,
            data: dataC,
          });
        }}
      >
        Change
      </button>
    </TableCell>
  );

  return (
    <>
      {isLoading && <Spinner />}

      <h1 className="text-center mb-1 mt-2 text-lg font-bold font-inter underline ">Security Master</h1>

      <div className="px-4">
        <div className="flex font-inter">
          <Table
            isStriped
            isHeaderSticky
            removeWrapper
            className="w-full text-sm text-left text-gray-500 "
            aria-label="collection table"
            classNames={{
              td: "group-data-[odd=true]/tr:before:bg-blue-100", // light blue
            }}
          >
            <TableHeader className="text-gray-700 uppercase bg-gray-50 sticky top-0">
              <TableColumn className="text-sm px-2 py-1 text-center">ID</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400" style={{ userSelect: "all" }}>
                Name{" "}
                <input
                  type="search"
                  className="block p-1 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 mx-auto z-50"
                  placeholder="Search"
                  onKeyDown={(event: any) => {
                    if (event.key === "Enter") {
                      let _filters = { ...filters };
                      let val = event.target?.value;
                      if (!val) {
                        delete _filters["name"];
                      } else {
                        _filters["name"] = { $like: `%${val}%` };
                      }
                      setFilters(_filters);
                    }
                  }}
                />
              </TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">Role</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">Active?</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                TOTP
                <br />
                Setup?
              </TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                Force
                <br />
                TOTP?
              </TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                Is Third
                <br />
                Party?
              </TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center">Approve</TableColumn>

              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                New
                <br />
                Booking
              </TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                Confirm
                <br />
                Pickup
              </TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">PRS</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">DRS</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">MISC</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">Tally</TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                Out
                <br />
                Scan
              </TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                In
                <br />
                Scan
              </TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                DRS
                <br />
                Gen.
              </TableColumn>
              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                Link
                <br />
                TP
              </TableColumn>

              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                Direct
                <br />
                Pod
              </TableColumn>

              <TableColumn className="text-sm px-2 py-1 text-center border-x border-gray-400">
                Parcel
                <br />
                Photo
              </TableColumn>
            </TableHeader>

            <TableBody>
              {!tableData.length && (
                <TableRow>
                  <TableCell colSpan={20} className="text-center">
                    No Data Found
                  </TableCell>
                </TableRow>
              )}
              {tableData.map((rd, j) => {
                return (
                  <>
                    <TableRow className={`${rd.isActive ? "" : "bg-red-300  text-black-900"}`} key={"tbl-tr-" + rd.id}>
                      <TableCell>{rd.id}</TableCell>
                      <TableCell className="border-x border-gray-300">
                        <span className="text-black-900">{rd.name}</span>
                        <br />
                        <span className="text-xs">(id:{rd.username})</span>
                      </TableCell>
                      <TableCell className="border-x border-gray-300">
                        {rd?._role_name?.name || "-"}
                        <br />
                        <span className="text-xs font-semibold underline">({rd?._subbranch?.branch_name || "-"})</span>
                      </TableCell>
                      <TableCell className="text-center border-x border-gray-300">
                        <Chip color={rd.isActive ? "success" : "danger"} size="sm" variant="solid">
                          <span className="font-semibold px-2">{rd.isActive ? "Yes" : "No"}</span>
                        </Chip>
                        <br />
                        <button
                          className="ml-2 text-dark1 font-medium"
                          onClick={() => {
                            let dataC = { isActive: !rd.isActive };
                            updateBookingMutate({
                              url: "/admin/user/update/" + rd.id,
                              data: dataC,
                            });
                          }}
                        >
                          Change
                        </button>
                      </TableCell>
                      <TableCell className="text-center border-x border-gray-300">
                        <Chip color={rd.extraPerm?.is_totp_enabled ? "success" : "danger"} size="sm" variant="solid">
                          <span className="font-semibold px-2">{rd.extraPerm?.is_totp_enabled ? "Yes" : "No"}</span>
                        </Chip>
                        <br />
                        <button
                          className="ml-2 text-dark1 font-medium"
                          onClick={() => {
                            let dataC = { extraPerm: { ...rd.extraPerm, is_totp_enabled: false } };
                            updateBookingMutate({
                              url: "/admin/user/update/" + rd.id,
                              data: dataC,
                            });
                          }}
                        >
                          Reset
                        </button>
                      </TableCell>
                      <TableCell className="text-center border-x border-gray-300">
                        <Chip color={rd.extraPerm?.force_totp ? "success" : "danger"} size="sm" variant="solid">
                          <span className="font-semibold px-2">{rd.extraPerm?.force_totp ? "Yes" : "No"}</span>
                        </Chip>
                        <br />
                        <button
                          className="ml-2 text-dark1 font-medium"
                          onClick={() => {
                            let dataC = { extraPerm: { ...rd.extraPerm, force_totp: !rd.extraPerm?.force_totp } };
                            updateBookingMutate({
                              url: "/admin/user/update/" + rd.id,
                              data: dataC,
                            });
                          }}
                        >
                          Change
                        </button>
                      </TableCell>
                      <TableCell className="text-center border-x border-gray-300">
                        <Chip color={rd.isThirdParty ? "secondary" : "warning"} size="sm" variant="solid">
                          <span className="font-semibold px-2">{rd.isThirdParty ? "Yes" : "No"}</span>
                        </Chip>
                        <br />
                        <button
                          className="ml-2 text-dark1 font-medium"
                          onClick={() => {
                            let dataC = { isThirdParty: !rd.isThirdParty };
                            updateBookingMutate({
                              url: "/admin/user/update/" + rd.id,
                              data: dataC,
                            });
                          }}
                        >
                          Change
                        </button>
                      </TableCell>
                      <TableCell className="font-semibold text-center">
                        <button className="text-dark1" onClick={() => mutateApproveDeviceId(rd.id)}>
                          Approve
                        </button>
                      </TableCell>

                      {ExtraPermCell("new_booking", rd)}
                      {ExtraPermCell("conf_pickup", rd)}
                      {ExtraPermCell("prs", rd)}
                      {ExtraPermCell("drs", rd)}
                      {ExtraPermCell("misc_travel", rd)}
                      {ExtraPermCell("mb_tally", rd)}
                      {ExtraPermCell("mb_out", rd)}
                      {ExtraPermCell("mb_in", rd)}
                      {ExtraPermCell("gen_drs", rd)}
                      {ExtraPermCell("link_tp", rd)}
                      {ExtraPermCell("directPod", rd)}
                      {ExtraPermCell("awbPhotoUpload", rd)}
                    </TableRow>
                  </>
                );
              })}
            </TableBody>
          </Table>
        </div>

        <nav className="flex items-center justify-between pt-4" aria-label="Table navigation">
          <span className="text-sm font-normal text-gray-500">
            Total: <span className="font-semibold text-gray-900">{itemCount}</span>
          </span>
          <ul className="inline-flex -space-x-px text-sm h-8">
            <li>
              <div
                onClick={() => serCurrentPage((prevData) => (prevData > 1 ? prevData - 1 : prevData))}
                className="flex items-center justify-center px-3 h-8 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 "
              >
                Previous
              </div>
            </li>
            {Array.from({ length: pageCount }, (_, i) => i + 1).map((p) => (
              <li key={"paginate-" + p}>
                <button
                  onClick={() => serCurrentPage(p)}
                  type="button"
                  aria-current={currentPage === p ? "page" : undefined}
                  className={`flex items-center justify-center px-3 h-8 border border-gray-300
                          ${
                            currentPage === p
                              ? "text-blue-600 bg-blue-50 hover:bg-blue-100 hover:text-blue-700"
                              : "text-gray-500 bg-white hover:bg-gray-100 hover:text-gray-700"
                          }`}
                >
                  {p}
                </button>
              </li>
            ))}
            <li>
              <div
                // href="#"
                onClick={() => serCurrentPage((prevData) => (prevData < pageCount ? prevData + 1 : prevData))}
                className="flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 "
              >
                Next
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default UserSecurity;
